<div [formGroup]="theForm" class="fieldWrapper">
    <label class="label" fxFlex="1 1 60%">
        <span matTooltip="{{ metaData?.description }}">{{ metaData?.friendlyName }}</span>
    </label>
    <span class="toggle" fxFlex="1 1 40%">
        <mat-button-toggle-group
            #formControl
            color="primary"
            [formControlName]="metaData?.inputName"
            matTooltip="{{ metaData?.description }}"
        >
            <mat-button-toggle *ngFor="let option of options" [value]="option.value">{{ option.key }}</mat-button-toggle>
        </mat-button-toggle-group>
    </span>
    <div *ngIf="formControl.disabled && !isLoading && enableRetry">
        <mat-button-toggle (click)="getValueEmitter.emit()">Retry</mat-button-toggle>
    </div>
    <clare-spinner *ngIf="isLoading" text="Loading Value" position="absolute" overlay="true"></clare-spinner>
</div>
